import { Controller } from "stimulus";
import { openModal } from "../modal/utils";

export default class extends Controller {
  open() {
    openModal(document.querySelector(".review-form-overlay"));
  }
}
